export const HighFiveSvg = () => (
  <svg
    width="202"
    height="200"
    viewBox="0 0 202 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_10455_39689)">
      <path
        d="M134.939 11.6414C134.939 11.6414 101.498 -0.815337 69.0624 17.9344C36.6223 36.6883 20.6065 74.5212 6.8286 104.819C-6.95344 135.117 1.58167 166.215 26.7036 180.668C51.8213 195.117 68.5248 174.496 103.507 173.925C138.489 173.354 147.962 178.56 176.747 158.822C205.537 139.085 210.196 91.6748 186.854 56.2549C163.511 20.835 134.939 11.6456 134.939 11.6456V11.6414Z"
        fill="#0038FF"
      />
      <path
        opacity="0.7"
        d="M134.939 11.6414C134.939 11.6414 101.498 -0.815337 69.0624 17.9344C36.6223 36.6883 20.6065 74.5212 6.8286 104.819C-6.95344 135.117 1.58167 166.215 26.7036 180.668C51.8213 195.117 68.5248 174.496 103.507 173.925C138.489 173.354 147.962 178.56 176.747 158.822C205.537 139.085 210.196 91.6748 186.854 56.2549C163.511 20.835 134.939 11.6456 134.939 11.6456V11.6414Z"
        fill="white"
      />
      <g opacity="0.3">
        <path
          d="M164.886 110.005L159.195 115.695L164.886 121.386L170.576 115.695L164.886 110.005Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42.1475 9.41893L36.457 15.1094L42.1475 20.7998L47.8379 15.1094L42.1475 9.41893Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M31.8037 128.083L28.2852 131.602L31.8037 135.12L35.3223 131.602L31.8037 128.083Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.917 70.9736L8.39844 74.4922L11.917 78.0108L15.4356 74.4922L11.917 70.9736Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M155.784 30.2548L152.266 33.7734L155.784 37.292L159.303 33.7734L155.784 30.2548Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M39.6991 131.996L34.6953 137L39.6991 142.004L44.703 137L39.6991 131.996Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M139.491 126.661L135.973 130.18L139.491 133.698L143.01 130.18L139.491 126.661Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M166.48 23.0632L159.746 29.7969L166.48 36.5305L173.213 29.7969L166.48 23.0632Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M94.3155 182.067L90.7969 185.586L94.3155 189.105L97.8341 185.586L94.3155 182.067Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24.2464 75.9146C27.0705 75.9146 29.3599 73.6252 29.3599 70.8011C29.3599 67.9769 27.0705 65.6875 24.2464 65.6875C21.4222 65.6875 19.1328 67.9769 19.1328 70.8011C19.1328 73.6252 21.4222 75.9146 24.2464 75.9146Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M172.557 91.5432C175.224 91.5432 177.387 89.3806 177.387 86.713C177.387 84.0454 175.224 81.8828 172.557 81.8828C169.889 81.8828 167.727 84.0454 167.727 86.713C167.727 89.3806 169.889 91.5432 172.557 91.5432Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M189.889 56.3095C191.459 56.3095 192.731 55.037 192.731 53.4673C192.731 51.8975 191.459 50.625 189.889 50.625C188.319 50.625 187.047 51.8975 187.047 53.4673C187.047 55.037 188.319 56.3095 189.889 56.3095Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M133.065 16.2514C133.065 15.3095 132.303 14.5469 131.361 14.5469C130.419 14.5469 129.656 15.3095 129.656 16.2514C129.656 17.1933 130.419 17.9559 131.361 17.9559C132.303 17.9559 133.065 17.1933 133.065 16.2514Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M61.4662 115.12C62.4076 115.12 63.1708 114.357 63.1708 113.415C63.1708 112.474 62.4076 111.711 61.4662 111.711C60.5249 111.711 59.7617 112.474 59.7617 113.415C59.7617 114.357 60.5249 115.12 61.4662 115.12Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.1214 161.719C22.5346 161.719 23.6802 160.574 23.6802 159.16C23.6802 157.747 22.5346 156.602 21.1214 156.602C19.7081 156.602 18.5625 157.747 18.5625 159.16C18.5625 160.574 19.7081 161.719 21.1214 161.719Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M175.964 154.904C175.964 153.65 174.948 152.633 173.693 152.633C172.439 152.633 171.422 153.65 171.422 154.904C171.422 156.159 172.439 157.175 173.693 157.175C174.948 157.175 175.964 156.159 175.964 154.904Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M157.781 8.01349C157.781 6.75907 156.764 5.74219 155.51 5.74219C154.255 5.74219 153.238 6.75907 153.238 8.01349C153.238 9.26792 154.255 10.2848 155.51 10.2848C156.764 10.2848 157.781 9.26792 157.781 8.01349Z"
          stroke="#222222"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <path
        d="M66.863 95.2344L50.668 104.045"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M36.1758 47.2188L53.5086 54.0368"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M56.918 8.57812L67.9994 26.4777"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M94.7035 0.625L94.1367 14.8321"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M127.094 34.4358L141.584 19.9453"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M147.266 63.7009L159.768 59.4375"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M135.332 95.5234L145.847 101.491"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.2266 34.1562L61.7492 40.6909"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M144.996 46.3672L135.902 50.6306"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M56.3518 77.3359L46.6914 80.1782"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M139.312 81.0312L143.855 82.169"
        stroke="#222222"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M143.205 64.1156C141.601 63.0029 135.545 63.9906 131.715 67.0788C127.885 70.1669 127.023 71.2796 127.023 71.2796C127.023 71.2796 125.293 59.1729 125.293 58.802C125.293 58.4311 122.822 35.7014 122.33 32.3674C121.834 29.0333 121.097 24.0906 120.355 22.9779C119.613 21.8652 116.65 21.7443 115.662 22.2361L114.674 22.732C114.674 22.732 115.17 14.0844 114.178 11.9839C113.191 9.88351 110.103 11.1213 109.236 12.2298C108.373 13.3426 107.752 15.0721 107.752 15.0721C107.752 15.0721 104.91 14.0844 103.305 17.2976C101.701 20.5107 100.463 23.3488 100.217 26.437C99.9713 29.5251 98.6127 33.4801 98.6127 33.4801C98.6127 33.4801 97.0082 30.8879 95.2787 32.3674C93.5491 33.851 91.5737 39.6564 91.0778 43.8573C90.5819 48.0581 90.0901 59.1729 90.0901 59.1729C90.0901 59.1729 89.1024 64.2365 88.6065 68.3124C88.1105 72.3882 88.4814 89.3126 90.336 96.3515C92.1905 103.395 94.6577 107.841 94.6577 107.841C94.6577 107.841 98.9794 122.049 99.6004 124.024C100.217 125.999 107.01 152.93 107.01 152.93L127.269 127.237C127.269 127.237 122.205 113.28 121.092 110.067C119.98 106.854 119.238 105.866 119.238 105.866C119.238 105.866 125.414 97.0934 128.748 94.5011C132.082 91.9089 133.812 83.2613 134.679 79.4313C135.541 75.6014 139.125 70.2919 141.101 68.5624C143.076 66.8329 144.806 65.2284 143.201 64.1156H143.205ZM97.5 58.1852C97.1291 58.1852 97.2541 53.3676 97.2541 47.5622C97.2541 41.7568 98.2418 39.1604 98.2418 39.1604C97.7459 41.7526 98.7377 54.6012 98.7377 55.468C98.7377 56.3349 97.8751 58.1852 97.5041 58.1852H97.5Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M116.18 107.976C117.726 107.193 118.005 106.359 118.005 106.359"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M104.047 105.125C104.047 105.125 110.84 109.572 114.178 108.709"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M127.023 71.2812C127.023 71.2812 124.431 75.3571 123.81 76.8407C123.193 78.3244 122.822 79.558 121.709 80.1748C120.597 80.7916 119.117 81.6584 119.117 81.6584"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M119.558 72.4844C116.415 73.943 111.993 76.5227 109.48 80.2943"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M123.194 71.0312C123.194 71.0312 122.289 71.3146 120.914 71.8898"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M108.123 81.9062C108.123 81.9062 105.898 85.9821 104.91 89.1953"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M107.752 15.0781C107.752 15.0781 107.135 20.2667 106.268 28.0475C105.406 35.8283 104.91 39.6582 105.035 44.6009C105.16 49.5436 106.518 53.8654 106.393 54.4822"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M114.672 22.7344C114.672 22.7344 114.301 25.9475 114.672 30.1443C115.043 34.3451 114.301 42.1259 114.301 45.0932C114.301 48.0605 114.426 52.5031 114.547 53.8617C114.668 55.2203 115.409 56.208 115.409 56.208"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M117.016 56.9531C117.016 56.9531 117.632 58.0659 121.708 58.1867"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M107.629 53.9922C107.629 53.9922 110.592 54.609 112.572 54.2381"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M96.881 59.1797C96.881 59.1797 96.881 60.4133 93.2969 61.526"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M103.922 55.8385C104.293 55.5926 105.776 55.0967 106.147 53.3672"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M104.133 74.7643C104.133 74.7643 111.814 71.9471 116.677 70.9219"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M125.937 199.794H192.343C187.704 193.672 170.776 171.363 169.672 170.263C168.392 168.984 162.758 168.217 162.758 168.217L146.117 154.393L125.379 120.086L105.667 147.479L102.337 134.164L94.9102 161.815C94.9102 161.815 121.795 194.589 122.816 195.868C123.016 196.118 124.175 197.585 125.933 199.798L125.937 199.794Z"
        fill="#222222"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M73.943 103.744C73.943 103.744 68.446 89.6662 67.1207 87.074C65.7954 84.4818 58.6023 73.2253 58.2397 70.1705C57.8771 67.1157 56.7519 62.0354 55.5933 59.91C54.4347 57.7846 57.8855 56.3926 60.7402 59.0848C63.5908 61.7771 65.3162 66.1571 65.2787 67.4199C65.2412 68.6827 71.68 73.4003 71.68 73.4003L72.8511 62.5481C72.8511 62.5481 74.1013 35.6299 73.8388 31.6124C73.5762 27.5949 73.3178 19.064 76.506 18.7348C79.6942 18.4055 80.1901 20.9269 80.1901 20.9269C80.1901 20.9269 80.3026 14.5714 83.8492 14.9798C86.5581 15.2924 87.5958 17.8471 87.9917 19.0765C88.3876 20.3059 88.8544 21.8312 88.8544 21.8312C88.8544 21.8312 91.0882 20.3143 93.2678 23.9275C94.5181 26.0029 97.177 32.5293 97.6062 34.188C98.0355 35.8467 98.1689 36.4468 98.1689 36.4468C98.1689 36.4468 101.157 36.3509 102.482 39.5058C103.808 42.6606 105.691 50.8915 107.512 57.7012C109.334 64.511 109.259 70.979 109.259 70.979C109.259 70.979 109.971 92.8877 108.504 99.8558C107.037 106.824 104.278 112.763 103.712 113.329C103.145 113.896 94.9932 137.951 94.9932 137.951L66.7206 127.47C66.7206 127.47 72.6094 113.004 73.5387 109.85C74.4722 106.699 73.943 103.744 73.943 103.744Z"
        fill="white"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M68.0273 83.2109C68.0857 84.5904 68.3816 85.4197 68.3816 85.4197"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M70.8167 74.6016C70.8167 74.6016 69.2206 76.4603 68.3912 79.7776C68.2245 80.4444 68.1245 81.0696 68.0703 81.6447"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M80.1876 20.9375C80.1876 20.9375 80.6794 29.6685 81.0044 33.9819C81.3337 38.2953 81.492 44.9675 81.5212 49.3518C81.5504 53.7318 81.0169 59.2413 80.7169 60.4374C80.4168 61.6335 79.75 63.1588 79.75 63.1588"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M88.8478 21.8359C88.8478 21.8359 87.4517 23.4613 87.9143 25.5534C88.3769 27.6455 90.5231 39.3312 90.5231 41.0233C90.5231 42.7153 90.644 57.4183 90.6732 58.4144C90.7065 59.4104 90.0064 62.7611 89.673 64.0906"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M98.162 36.4531C98.162 36.4531 96.57 36.6157 96.9326 39.1078C97.2952 41.6 98.087 49.6976 98.0829 51.9522C98.0829 54.211 98.608 59.4204 98.5038 64.3339C98.3996 69.2475 99.529 70.9395 100.058 72.2022"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M73.5736 69.2266C73.5736 69.2266 73.0069 72.048 73.7695 73.5066C74.5322 74.9694 75.5907 78.0534 75.5907 79.7496"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M79.2853 67.8359C79.2853 67.8359 78.9852 70.1573 79.3144 71.6534C79.6437 73.1495 80.6731 74.6749 80.6731 74.6749"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M88.8078 71.4922C88.8078 71.4922 88.4744 73.9469 89.0704 75.5097C89.6663 77.0684 90.3623 78.2311 90.3623 78.2311"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M75.9874 199.79L102.272 140.482C102.272 140.482 91.0572 131.222 83.6807 126.362C76.3042 121.503 67.4565 121.649 67.4565 121.649C67.4565 121.649 55.9082 146.258 55.3039 147.825C54.6955 149.392 46.6438 166.067 46.6438 166.067C46.6438 166.067 43.1056 167.329 41.5344 170.155C40.305 172.372 31.4323 191.58 27.6523 199.79H75.9874Z"
        fill="#0038FF"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M94.5846 144.377C95.7495 143.688 96.1353 142.186 95.4464 141.021C94.7575 139.856 93.2546 139.47 92.0897 140.159C90.9248 140.848 90.539 142.351 91.2279 143.516C91.9168 144.68 93.4196 145.066 94.5846 144.377Z"
        fill="#222222"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M92.0167 152.022C91.6874 153.335 90.358 154.131 89.0452 153.802C87.7324 153.473 86.9364 152.143 87.2657 150.83C87.5949 149.518 88.9244 148.722 90.2371 149.051C91.5499 149.38 92.3459 150.71 92.0167 152.022Z"
        fill="#222222"
        stroke="#222222"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10455_39689">
        <rect
          width="201.471"
          height="200"
          fill="white"
          transform="translate(0.265625)"
        />
      </clipPath>
    </defs>
  </svg>
)
